import {
    Button, Dialog, DialogActions, DialogContent, DialogTitle
} from "@material-ui/core";
import PropTypes from "prop-types";
import React from "react";
import { globalStyles } from "../../assets/globalStyles";
import { useStyles } from "./netzwirtschaftStyles";
import { NetzwirtschaftSavedSearchGrid } from "./savedSarchGrid";




export interface NetzwirtschaftSavedSearchProps {
    openSavedSearchesDialog: boolean;
    setOpenSavedSearchesDialog: (newValue: boolean) => void;
}



export const NetzwirtschaftSavedSearch = ({ openSavedSearchesDialog, setOpenSavedSearchesDialog }: NetzwirtschaftSavedSearchProps): JSX.Element => {


    const classes = {
        ...useStyles(),
        ...globalStyles(),
    };

    return (
        <Dialog
            open={openSavedSearchesDialog}
            onClose={() => setOpenSavedSearchesDialog(false)}
            fullWidth
            maxWidth="xl"
        >
            <DialogTitle>Gespeicherte Suchen</DialogTitle>
            <DialogContent>
                <NetzwirtschaftSavedSearchGrid setOpenSavedSearchesDialog={setOpenSavedSearchesDialog} />
            </DialogContent>
            <DialogActions>
                <Button
                    color="default"
                    variant="contained"
                    onClick={() => setOpenSavedSearchesDialog(false)}
                    className={classes.cancleDeleteButton}
                >
                    Schließen
                </Button>
            </DialogActions>
        </Dialog>

    );
}
NetzwirtschaftSavedSearch.propTypes = {
    openSavedSearchesDialog: PropTypes.bool.isRequired,
    setOpenSavedSearchesDialog: PropTypes.func.isRequired
};
